<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
>
  @if (isPossibleToEdit()) {
    <input
      matInput
      appDateInput
      [(ngModel)]="value"
      [matDatepicker]="picker"
      [required]="required"
      (input)="onInputChange($event)"
      (dateChange)="handleDateInputChange($event)"
      placeholder="ДД.ММ.ГГГГ"
    >
    <div class="toggle">
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker">
      </mat-datepicker-toggle>
      @if (isFilter) {
        <mat-datepicker-toggle
          matSuffix
          (click)="clearDatePicker()"
        >
          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
        </mat-datepicker-toggle>
      }
    </div>
    <mat-datepicker #picker></mat-datepicker>
  } @else {
    <div class="value-container">
      {{ value | russianDate }}
    </div>
  }
</div>

